import type { ReactNode } from 'react';
import AppLayout from './AppLayout';

type Props = {
  projectId: string;
  children: ReactNode;
};

export default function AppShell({ children }: Props) {
  return <AppLayout>{children}</AppLayout>;
}
